export default __webpack_public_path__ + "static/media/slider01.53df33f7.webp";